var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"btn",class:[
			_vm.type && `btn-${_vm.type}`,
			_vm.marginReset ? 'margin-reset' : ''
		],attrs:{"href":_vm.path,"title":_vm.title},on:{"click":function($event){$event.preventDefault();return _vm.handleClick()}}},[_c('div',{staticClass:"content-wrapper"},[(_vm.icon)?_vm._t("icon",function(){return [_c('base-svg',{staticClass:"btn-icon",attrs:{"name":_vm.icon}})]}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }